<template>
    <div ref="scroll-items" class="scroll-items" @scroll.stop="listenScroll($event)">
        <div ref="scroll-item" class="scroll-item my-cursor"
             :class="{'selected-item': item === selected}"
             @click="toTargetItem(item)"
             v-for="(item) in items">{{item}}</div>
    </div>
</template>

<script>
export default {
    name: "ScrollModule",
    data(){
        return {
            timer: null,
        }
    },
    props: {
        items: {
            type: Array,
            default: ()=> { return [] },
        },
        selected: {
            type: String,
            default: "",
        },
    },
    watch: {
        selected: function(){
            this.toTargetHeight();
        },
    },
    methods: {
        listenScroll: function (e){
            if(this.timer !== null){
                clearTimeout(this.timer);
            }
            const itemsDom = this.$refs["scroll-item"];
            const childHeight = itemsDom[0].offsetHeight
            let scrollTop = parseInt(e.target.scrollTop);
            const index = (scrollTop / childHeight).toFixed();
            scrollTop = itemsDom[index].offsetTop - e.target.offsetTop - itemsDom[index].offsetHeight;

            let that = this;
            this.timer = setTimeout(()=>{
                e.target.scrollTo({
                    top: scrollTop,
                    behavior: "smooth",
                });
                that.toTargetItem(that.items[index]);
            }, 100)
        },
        toTargetHeight: function(){
            let targetItem = 0;
            for (let i=0, l=this.items.length; i<l; i++){
                if(this.items[i] === this.selected){
                    targetItem = i
                }
            }
            const scrollDom = this.$refs["scroll-items"];
            const itemsDom = this.$refs["scroll-item"];
            let scrollTop;
            try{
                scrollTop = itemsDom[targetItem].offsetTop - scrollDom.offsetTop - itemsDom[targetItem].offsetHeight;
            }catch(error){
                return
            }
            scrollDom.scrollTo({
                top: scrollTop,
                behavior: "smooth",
            });
        },
        toTargetItem: function(item){
            this.$emit("submitEvent", item);
        },
    },
    beforeDestroy(){
        clearInterval(this.timer);
        this.timer = null;
    },
}
</script>

<style scoped>
div.scroll-items{
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0.4rem 0;
}
div.scroll-item{
    height: 0.4rem;
    font-weight: bold;
    font-size: 0.2rem;
    line-height: 0.4rem;
    color: rgba(0, 0, 0, 0.5);
}
div.scroll-item:nth-of-type(2n){
}

div.selected-item{
    font-size: 0.22rem;
    color: #000000;
}
</style>